<script>
import Colorable from '../../mixins/Colorable';

export default {
    name: 'Button',
    mixins: [Colorable],
    props: {
        outline: Boolean,
        flat: Boolean,
        small: Boolean,
        disabled: {
            type: [Boolean, String],
            default: false,
            validator (value) {
                if (typeof value === 'boolean') {
                    return true;
                } else if (typeof value === 'string') {
                    return ['full', 'shallow'].includes(value);
                } else {
                    return false;
                }
            },
        },
        to: {
            type: [Object, String],
            default: null,
        },
    },
    computed: {
        style () {
            if (this.outline) {
                return {
                    borderColor: this.color,
                    color: this.color,
                };
            } else if (this.flat) {
                return {
                    color: this.color,
                };
            } else {
                return {
                    borderColor: this.color,
                    backgroundColor: this.color,
                };
            }
        },
        classes () {
            return {
                solid: !this.outline && !this.flat,
                outline: this.outline,
                flat: this.flat,
                small: this.small,
                disabled: !!this.disabled,
            };
        },
        domProps () {
            return {
                disabled: this.disabled === true || this.disabled === 'full',
            };
        },
    },
    render (h) {
        const data = {
            style: this.style,
            class: this.classes,
            on: this.$listeners,
            domProps: this.domProps,
        };

        if (this.to) {
            return h('router-link', {
                ...data,
                props: {
                    to: this.to,
                    tag: 'button',
                },
            }, this.$slots.default);
        } else {
            return h('button', data, this.$slots.default);
        }
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/colors';

@mixin button-solid ($color) {
    border: 2px solid $color;
    background-color: $color;
    color: $white;
}

@mixin button-outline ($color) {
    border: 2px solid $color;
    color: $color;
}

button {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 160px;
    padding: 6px 18px;
    border-radius: 30px;
    outline: none;
    border: 1px solid;
    font-family: inherit;
    font-size: 14px;
    /* font-weight: bold; */
    line-height: 32px;
    white-space: nowrap;
    cursor: pointer;
    transition: all .3s ease-in-out;
    user-select: none;

    &.solid {
        color: $white;
    }

    &.outline {
        background-color: transparent;
    }

    &.flat {
        background-color: transparent;
        border: none;
    }

    &.small {
        font-size: 12px;
        padding: 2px 6px;
        min-width: 120px;
    }

    &.disabled {
        cursor: not-allowed;
        border-color: $grey-lightest !important;
        background-color: $grey-lightest !important;
        color: $white !important;

        &:disabled {
            pointer-events: none;
        }
    }

    &:not(.disabled):hover {
        filter: brightness(1.1);
    }

    > a {
        text-decoration: none;
        color: inherit;
    }
}
</style>
